import React from "react";
import { Card, Typography } from "antd";
import { useHistory } from "react-router-dom";
import { CompanyLogo } from "@bindeleddet/core/components";
import { Company } from "@bindeleddet/core/types";
import { useViewport } from "@bindeleddet/core/hooks";
import fallbackImg from "assets/images/fallbackImg.png";

const { Text } = Typography;

interface Props {
  company: Company;
}

const CompanyCard: React.FC<Props> = ({ company }) => {
  const history = useHistory();
  const { width } = useViewport();
  const breakpoint = 768;

  return (
    <Card
      bodyStyle={{
        padding: "1.5em",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        height: "100%",
      }}
      onClick={() => history.push(`/companies/${company.id}`)}
      hoverable
      style={{ width: "100%", maxWidth: "100%", height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          aspectRatio: "1 / 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 10,
          border: "1px solid #e0e0e0",
          backgroundColor: "white",
          padding: "10%",
          marginBottom: "12px",
        }}
      >
        {company.logo ? (
          <CompanyLogo size="100%" companyId={company.id} src={company.logo} />
        ) : (
          <img
            src={fallbackImg}
            alt={company.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        )}
      </div>
      <Text strong style={{ fontSize: width < breakpoint ? "14px" : "16px", wordBreak: "break-word" }}>
        {company.name}
      </Text>
    </Card>
  );
};

export default CompanyCard;
